import React, { useEffect, useState } from "react"
import {
  Field,
  FieldArray,
  FormSection,
  formValueSelector,
  initialize,
  reduxForm,
} from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { SaveButton } from "components/Buttons"
import { RadioField, TextAreaField, TextField } from "components/RenderInput"
import { connect } from "react-redux"
import { renderOptionsField } from "./utils"
import {
  addPoll,
  cloneMenuFeature,
  displayLockWarningModal,
  getPoll,
  getPollList,
  hideLockWarningModal,
  resetPoll,
  updatePoll,
} from "store/actions"
import {
  CloneFeatureModal,
  mapApiResponseToPoll,
  mapPollToApi,
  mapUpdatedPollToApi,
} from "../utils"
import validate from "./pollValidation"
import PropTypes from "prop-types"
import QuestionPreview from "./questionPreview"
import ResultsPreview from "./resultsPreview"
import { getPollsAxios } from "helpers/api_helper"
import ModalComponent from "components/Modals"
import { LoadingIndicator } from "components/LoadingIndicator"

let Poll = props => {
  const [previewToggle, setPreviewToggle] = useState(true)
  const [hasReplies, setHasReplies] = useState(false)

  useEffect(() => {
    const getHasReplies = async () => {
      try {
        const { has_replies } = await getPollsAxios(
          `/poll/${props.feature.entity_id}/has-replies`
        )
        setHasReplies(has_replies)
      } catch (error) {
        console.error(error)
      }
    }

    if (props.feature.entity_id) {
      getHasReplies()
      props.getPoll(props.feature.entity_id)
    }

    return () => {
      props.resetPoll()
    }
  }, [])

  useEffect(() => {
    if (props.poll) {
      props.initializeForm({ poll_form: mapApiResponseToPoll(props.poll) })
    }
  }, [props.poll])

  const handleFieldFocus = event => {
    if (hasReplies) {
      event.preventDefault()
      props.displayLockWarningModal()
    }
  }

  const handleSubmit = data => {
    if (!props.feature.entity_id) {
      const [questions, poll] = mapPollToApi({
        ...data.poll_form,
        event_id: props?.selectedEvent?.id,
        menu_feature: true,
        menu_item_id: props.feature.id,
        name: props.feature.label,
        order: 0,
        status: 0,
        user_id: props.userId,
        vendor_id: props.vendorId,
      })
      props.addPoll(questions, poll)
    } else {
      const [questions, poll] = mapUpdatedPollToApi(data.poll_form, props.poll)
      props.updatePoll(questions, poll)
    }
  }

  return (
    <React.Fragment>
      <FormSection name={props.form}>
        {props?.loading ? (
          <LoadingIndicator />
        ) : (
          <Card>
            <CardBody className="shadow-sm">
              <Row className="mb-3">
                <Col>
                  <h3>{props.feature.label}</h3>
                </Col>
                {props.isListItem && (
                  <Col xs="auto">
                    <SaveButton
                      type="button"
                      content="Cancel"
                      color="light"
                      onClick={props.backButtonHandler}
                    />
                  </Col>
                )}
                <Col xs="auto">
                  <SaveButton
                    type="button"
                    content="Save"
                    onClick={
                      props.isListItem
                        ? props.handleSubmit(props.handleAddListItem)
                        : props.handleSubmit(handleSubmit)
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  {props.isListItem && (
                    <Card className="my-2">
                      <CardHeader>
                        <h4>CREATE A NAME FOR YOUR POLL</h4>
                      </CardHeader>
                      <CardBody>
                        <Row className="mb-2">
                          <Col>
                            <Field
                              name="name"
                              component={TextField}
                              label="Name"
                            />
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  )}
                  <Card>
                    <CardHeader>
                      <h4>POLL QUESTION AND OPTIONS</h4>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col className="my-1">
                          <p>
                            Create your poll question and give answer options.
                          </p>
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col className="my-1">
                          <Field
                            name="question"
                            component={TextAreaField}
                            rows={2}
                            label="Poll Question"
                            onFocus={handleFieldFocus}
                          />
                        </Col>
                      </Row>
                      <Row className="my-1">
                        <Col xs={12}>
                          <label>Answers:</label>
                        </Col>
                        <Col>
                          <FieldArray
                            name="options"
                            component={renderOptionsField}
                            handleFieldFocus={handleFieldFocus}
                            hasReplies={hasReplies}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Card>
                    <CardHeader>
                      <h4>POLL RESULTS</h4>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col>
                          <p>
                            Choose which chart type to display the Poll results.
                            Next, choose if you would like to display the
                            results metrics as a percentage or number.
                          </p>
                        </Col>
                      </Row>
                      <Row className="my-3">
                        <Col xs={4} lg={3} style={{ minWidth: "fit-content" }}>
                          Chart Type:
                        </Col>
                        <Col>
                          <Row>
                            <Field
                              name="chartType"
                              value="0"
                              type="radio"
                              label="Concentric Circles"
                              component={RadioField}
                            />
                          </Row>
                          <Row>
                            <Field
                              name="chartType"
                              value="1"
                              type="radio"
                              label="Horizontal Bar"
                              component={RadioField}
                            />
                          </Row>
                          <Row>
                            <Field
                              name="chartType"
                              value="2"
                              type="radio"
                              label="Pie"
                              component={RadioField}
                            />
                          </Row>
                        </Col>
                      </Row>
                      <Row className="my-3">
                        <Col xs={4} lg={3} style={{ minWidth: "fit-content" }}>
                          Result Metrics:
                        </Col>
                        <Col>
                          <Row>
                            <Field
                              name="resultMetrics"
                              value="0"
                              type="radio"
                              label="Percentages"
                              component={RadioField}
                            />
                          </Row>
                          <Row>
                            <Field
                              name="resultMetrics"
                              value="1"
                              type="radio"
                              label="Poll Counts"
                              component={RadioField}
                            />
                          </Row>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Row>
                    <Col className="d-flex justify-content-center">
                      <SaveButton
                        type="button"
                        content="Save"
                        onClick={
                          props.isListItem
                            ? props.handleSubmit(props.handleAddListItem)
                            : props.handleSubmit(handleSubmit)
                        }
                      />
                    </Col>
                  </Row>
                </Col>
                <Col xl={4} className="mt-4 custom-features-preview">
                  <Row>
                    <p style={{ textAlign: "center", margin: "0px" }}>
                      <b>
                        {previewToggle ? "Question Preview" : "Results Preview"}
                      </b>
                    </p>
                  </Row>
                  <Row xs="auto" className="d-flex justify-content-center my-2">
                    <SaveButton
                      type="button"
                      content="Toggle Screens"
                      onClick={() => setPreviewToggle(!previewToggle)}
                    />
                  </Row>
                  {previewToggle ? (
                    <QuestionPreview
                      bgImage={props.design?.bg_image_url}
                      question={props.formValues?.question}
                      options={props.formValues?.options}
                      menu_bg_color={props.design?.menu_bg_color}
                    />
                  ) : (
                    <ResultsPreview
                      bgImage={props.design?.bg_image_url}
                      question={props.formValues?.question}
                      options={props.formValues?.options}
                      menu_bg_color={props.design?.menu_bg_color}
                      chartType={props.formValues?.chartType}
                    />
                  )}
                </Col>
              </Row>
            </CardBody>
          </Card>
        )}
      </FormSection>
      <ModalComponent
        title={`Clone Poll Menu Feature`}
        open={props.lockWarningModalIsOpen}
        onClose={props.hideLockWarningModal}
        returnFocusAfterClose={false}
      >
        <CloneFeatureModal
          handleClone={() => {
            props?.cloneMenuFeature({
              data: {
                vendor_id: +props?.vendorId,
                entity_type: "poll",
                entity_id: props?.poll?.id,
                menu_item_id: props?.poll?.menu_item_id,
              },
              callback: props?.isListItem
                ? () => {
                    props.getPollList({
                      menu_item_id: props.poll?.menu_item_id,
                      vendor_id: parseInt(props.vendorId),
                      ...(!!props?.selectedEvent
                        ? { event_id: props.selectedEvent.id }
                        : {}),
                    })
                  }
                : null,
            })
          }}
          handleCloseModal={props.hideLockWarningModal}
          featureName={"Poll"}
          loading={props?.loading}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

Poll = reduxForm({
  form: FORM_NAMES.POLL,
  initialValues: {
    poll_form: {
      options: [
        { id: null, answer: "" },
        { id: null, answer: "" },
      ],
      chartType: "0",
      resultMetrics: "0",
    },
  },
  validate,
})(Poll)

const selector = formValueSelector(FORM_NAMES.POLL)

const mapStateToProps = state => ({
  poll: state.Poll.poll,
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  userId: state.Login.authUser.id,
  formValues: selector(state, "poll_form"),
  lockWarningModalIsOpen: state.menuFeatures.lockWarningModalIsOpen,
  loading: state.menuFeatures.loading,
  loading: state.Poll.loading,
})

const mapDispatchToProps = dispatch => ({
  getPoll: values => dispatch(getPoll(values)),
  addPoll: (questions, poll) => dispatch(addPoll(questions, poll)),
  resetPoll: () => dispatch(resetPoll()),
  initializeForm: values => dispatch(initialize(FORM_NAMES.POLL, values)),
  updatePoll: (questions, poll) => dispatch(updatePoll(questions, poll)),
  displayLockWarningModal: () => dispatch(displayLockWarningModal()),
  cloneMenuFeature: values => dispatch(cloneMenuFeature(values)),
  hideLockWarningModal: () => dispatch(hideLockWarningModal()),
  getPollList: values => dispatch(getPollList(values)),
})

Poll.propTypes = {
  feature: PropTypes.object,
  handleAddListItem: PropTypes.func,
  isListItem: PropTypes.bool,
  backButtonHandler: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(Poll)
